import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Label } from "ui/Scripts/source/components/framework/FormField/FormField.styles";

export interface ITaskDynamicFormLabelProp {
    taskTypeCol: ITaskTypeCol;
}

export class TaskDynamicFormLabel extends React.Component<ITaskDynamicFormLabelProp, {}> {
    render() {
        const props = this.props;
        const col = props.taskTypeCol;
        return (
            !Base.isNullOrEmpty(col.title) ? <Label className="label">{col.title}</Label> : null
        );
    }
}